function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
};

checkForIcons = (id, activate = false) => {
    const container = document.getElementById(id);
    if(container != null) {
        const prev = id === 'img-scroll' ? container.nextElementSibling.firstElementChild : container.nextElementSibling;
        const next = id === 'img-scroll' ? container.nextElementSibling.firstElementChild.nextElementSibling : container.nextElementSibling.nextElementSibling;

        if (container.offsetWidth < container.scrollWidth) {
            if(!activate) {
                if (container.scrollLeft > 0
                    && prev.classList.contains('xhidden')) {
                    prev.classList.remove("xhidden");
                }
                if (container.scrollLeft === 0
                    && !prev.classList.contains('xhidden')) {
                    prev.classList.add("xhidden");
                }
                if ((container.scrollLeft + container.clientWidth) !== container.scrollWidth
                    && next.classList.contains('xhidden')) {
                    next.classList.remove("xhidden");
                } else if ((container.scrollLeft + container.clientWidth) >= container.scrollWidth
                    && !next.classList.contains('xhidden')) {
                    next.classList.add("xhidden");
                }
            } else {
                if (container.scrollLeft > 0
                    && !prev.classList.contains('active')) {
                    prev.classList.add("active");
                }
                if (container.scrollLeft === 0
                    && prev.classList.contains('active')) {
                    prev.classList.remove("active");
                }
                if ((container.scrollLeft + container.clientWidth) !== container.scrollWidth
                    && !next.classList.contains('active')) {
                    next.classList.add("active");
                } else if ((container.scrollLeft + container.clientWidth) >= container.scrollWidth
                    && next.classList.contains('active')) {
                    next.classList.remove("active");
                }
            }
        } else {
            if(!activate) {
                if (!prev.classList.contains('xhidden'))
                    prev.classList.add("xhidden");
                if (!next.classList.contains('xhidden'))
                    next.classList.add("xhidden");
            } else {
                if (prev.classList.contains('active'))
                    prev.classList.remove("active");
                if (next.classList.contains('active'))
                    next.classList.remove("active");
            }
        }
    }
};

scrollToLeft = (id) => {
    const container = document.getElementById(id);
    const firstEl = container.children.item(0);
    const gap = window.getComputedStyle(container, null).getPropertyValue("gap").replace("px", "");
    const size = firstEl.clientWidth + parseInt(gap);
    const scroll = size * Math.round(container.clientWidth / size) * -1;
    container.scrollBy(scroll, 0);
};
scrollToRight = (id) => {
    const container = document.getElementById(id);
    const firstEl = container.children.item(0);
    const gap = window.getComputedStyle(container, null).getPropertyValue("gap").replace("px", "");
    const size = firstEl.clientWidth + parseInt(gap);
    const scroll = size * Math.round(container.clientWidth / size);
    container.scrollBy(scroll, 0);
};